import { Schema, arrayOf } from 'normalizr'
import { agent } from 'components/agents/actions/schema'

export const member = new Schema('members')
export const arrayOfMembers = arrayOf(member)

member.define({
  agent: agent,
})
